const addOverlay = (state, id, key, props) => ({
  ...state,
  overlays: [
    ...(state.overlays.find((o) => o.key === key)
      ? removeOverlay(state, key).overlays
      : state.overlays),
    { id, key, props },
  ],
});

const replaceOverlay = (state, id, key, props) => ({
  ...state,
  overlays: [{ id, props, key }],
});

const removeOverlay = (state, { key, id }) => {
  return {
    ...state,
    overlays: state.overlays.filter(
      (overlay) => overlay.key !== key && overlay.id !== id
    ),
  };
};

export default {
  replaceOverlay,
  addOverlay,
  removeOverlay,
};
